module.exports = __webpack_public_path__ + "static/img/tips-section1-m.211f1e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tips-section1-m.jpg
// module id = 208
// module chunks = 0